import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

import { TableData } from '../tool-content.model';

/**
 * Renders a compact sortable table inline within a chat message.
 */
@Component({
  selector: 'app-ai-table',
  imports: [TranslocoModule],
  templateUrl: './ai-table.component.html',
  styleUrls: ['./ai-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    style: 'display: block; width: 100%; max-width: 100%;',
  },
})
export class AiTableComponent {
  readonly tableData = input.required<TableData>();

  protected readonly columns = computed(() => this.tableData().columns);
  protected readonly rows = computed(() => this.tableData().rows);
  protected readonly hasData = computed(() => this.rows().length > 0);

  protected cellValue(row: Record<string, unknown>, key: string): string {
    const val = row[key];
    if (val == null) {
      return '';
    }
    if (typeof val === 'number') {
      return val.toLocaleString();
    }
    return String(val);
  }
}
